import React, { useState, forwardRef} from "react";
import {Grid} from "@material-ui/core";
import ttAPI from '../../api/ttAPI';
import enNZ from 'date-fns/locale/en-NZ'
import config from '../../config';
import useStyles from './styles';


const AssetImages = forwardRef((props, ref) => {
    const classes = useStyles();
    const [asset, setAsset] = useState(props.asset);
    const [isAssetImageLoaded, setIsAssetImageLoaded] = useState(false);
    const [isAssetLocationImageLoaded, setIsAssetLocationImageLoaded] = useState(true);
    const [isAssetSerialImageLoaded, setIsAssetSerialImageLoaded] = useState(true);
    const [isAssetConditionImageLoaded, setIsAssetConditionImageLoaded] = useState(true);
    const [isAssetFailedImageLoaded, setIsAssetFailedImageLoaded] = useState(true);
    const [isAssetProofImageLoaded, setIsAssetProofImageLoaded] = useState(true);
    const [isAssetDocketImageLoaded, setIsAssetDocketImageLoaded] = useState(true);
    const [isAssetBatteryImageLoaded, setIsAssetBatteryImageLoaded] = useState(true);
    const [isAssetDischargeCurveImageLoaded, setIsAssetDischargeCurveImageLoaded] = useState(true);


  return (asset && <>
    <div className={classes.contentDiv}>

        <Grid container spacing={4}>

          <Grid item xs={12} md={6} sm={6}>
              <div className={classes.assetImagesBlock}>
                  <div className={classes.assetImagesDiv}>
                        <img
                            className="image thumb" title="asset photo"  alt="asset photo"
                            src={`${config.googleStorageUrl}${asset.qr}`}
                            style={{ display: isAssetImageLoaded ? "none" : "block" }}
                            onError={(e) => {e.target.src = `${config.hostApi}/client/img/no-image.png`; e.target.title = 'asset photo - not available'; e.target.alt = 'asset photo - not available';}}
                          />
                        <img
                            onLoad={() => {setIsAssetImageLoaded(true);}}
                            className="image full" title="asset photo"  alt="asset photo"
                            style={{ opacity: isAssetImageLoaded ? 1 : 0 }}
                            src={`${config.googleStorageUrl}${asset.qr}`}
                            onError={(e) => {e.target.src = `${config.hostApi}/client/img/no-image.png`; e.target.title = 'asset photo - not available'; e.target.alt = 'asset photo - not available';}}
                          />
                        <div>Asset Image</div><br/>
                  </div>
                  { isAssetLocationImageLoaded && (
                  <div className={classes.assetImagesDiv}>
                        <img
                            onLoad={() => {
                              setIsAssetLocationImageLoaded(true);
                            }}
                            className="image full" title="asset photo"  alt="asset photo"
                            style={{ opacity: isAssetLocationImageLoaded ? 1 : 0 }}
                            src={`${config.googleStorageUrl}${asset.qr}_l`}
                            onError={(e) => {
                              setIsAssetLocationImageLoaded(false);
                              e.target.src = `${config.hostApi}/client/img/no-image.png`;
                              e.target.title = 'asset location photo - not available';
                              e.target.alt = 'asset location photo - not available';}}
                          />
                        <div>Asset Location Image</div><br/>
                  </div>)}
                  { isAssetSerialImageLoaded && (
                  <div className={classes.assetImagesDiv}>
                        <img
                            onLoad={() => {setIsAssetSerialImageLoaded(true);}}
                            className="image full" title="asset serial photo" alt="asset serial photo"
                            style={{ opacity: isAssetSerialImageLoaded ? 1 : 0 }}
                            src={`${config.googleStorageUrl}${asset.qr}_s`}
                            onError={(e) => {setIsAssetSerialImageLoaded(false); e.target.src = `${config.hostApi}/client/img/no-image.png`; e.target.title = 'asset serial photo - not available'; e.target.alt = 'asset serial photo - not available';}}
                          />
                          <div>Serial Image</div><br/>
                  </div>)}
                  { isAssetConditionImageLoaded && (
                  <div className={classes.assetImagesDiv}>
                          <img
                              onLoad={() => {setIsAssetConditionImageLoaded(true);}}
                              className="image full" title="asset condition photo" alt="asset condition photo"
                              style={{ opacity: isAssetConditionImageLoaded ? 1 : 0 }}
                              src={`${config.googleStorageUrl}${asset.qr}_c`}
                              onError={(e) => {setIsAssetConditionImageLoaded(false); e.target.src = `${config.hostApi}/client/img/no-image.png`; e.target.title = 'asset condition photo - not available'; e.target.alt = 'asset condition photo - not available';}}
                            />
                            <div>Condition Image</div><br/>
                  </div>)}
                  { isAssetBatteryImageLoaded && (
                  <div className={classes.assetImagesDiv}>
                            <img
                                onLoad={() => {setIsAssetBatteryImageLoaded(true);}}
                                className="image full" title="asset failed photo" alt="asset battery photo"
                                style={{ opacity: isAssetBatteryImageLoaded ? 1 : 0 }}
                                src={`${config.googleStorageUrl}${asset.qr}_b`}
                                onError={(e) => {setIsAssetBatteryImageLoaded(false);  e.target.src = `${config.hostApi}/client/img/no-image.png`; e.target.title = 'asset battery photo  - not available'; e.target.alt = 'asset battery photo  - not available';}}
                              />
                              <div>Battery Image</div><br/>
                  </div>)}
                  { isAssetDischargeCurveImageLoaded && (
                  <div className={classes.assetImagesDiv}>
                            <img
                                onLoad={() => {setIsAssetDischargeCurveImageLoaded(true);}}
                                className="image full" title="asset discharge curve photo" alt="asset discharge curve photo"
                                style={{ opacity: isAssetDischargeCurveImageLoaded ? 1 : 0 }}
                                src={`${config.googleStorageUrl}${asset.qr}_dc`}
                                onError={(e) => {setIsAssetDischargeCurveImageLoaded(false);  e.target.src = `${config.hostApi}/client/img/no-image.png`; e.target.title = 'asset discharge curve photo  - not available'; e.target.alt = 'asset discharge curve photo  - not available';}}
                              />
                              <div>Discharge Curve Image</div><br/>
                  </div>)}
                  { isAssetFailedImageLoaded && (
                  <div className={classes.assetImagesDiv}>
                            <img
                                onLoad={() => {setIsAssetFailedImageLoaded(true);}}
                                className="image full" title="asset failed photo" alt="asset failed photo"
                                style={{ opacity: isAssetFailedImageLoaded ? 1 : 0 }}
                                src={`${config.googleStorageUrl}${asset.qr}_f`}
                                onError={(e) => {setIsAssetFailedImageLoaded(false);  e.target.src = `${config.hostApi}/client/img/no-image.png`; e.target.title = 'asset failed photo  - not available'; e.target.alt = 'asset failed photo  - not available';}}
                              />
                              <div>Failed Image</div><br/>
                  </div>)}
                  { isAssetProofImageLoaded && (
                  <div className={classes.assetImagesDiv}>
                            <img
                                onLoad={() => {setIsAssetProofImageLoaded(true);}}
                                className="image full" title="asset proof photo" alt="asset proof photo"
                                style={{ opacity: isAssetProofImageLoaded ? 1 : 0 }}
                                src={`${config.googleStorageUrl}${asset.qr}_p`}
                                onError={(e) => {setIsAssetProofImageLoaded(false);  e.target.src = `${config.hostApi}/client/img/no-image.png`; e.target.title = 'asset proof photo  - not available'; e.target.alt = 'asset proof photo  - not available';}}
                              />
                              <div>Proof Image</div><br/>
                  </div>)}
                  { isAssetDocketImageLoaded && (
                  <div className={classes.assetImagesDiv}>
                            <img
                                onLoad={() => {setIsAssetDocketImageLoaded(true);}}
                                className="image full" title="asset docket photo" alt="asset docket photo"
                                style={{ opacity: isAssetDocketImageLoaded ? 1 : 0 }}
                                src={`${config.googleStorageUrl}${asset.qr}_do`}
                                onError={(e) => {setIsAssetDocketImageLoaded(false);  e.target.src = `${config.hostApi}/client/img/no-image.png`; e.target.title = 'asset docket photo  - not available'; e.target.alt = 'asset docket photo  - not available';}}
                              />
                              <div>Docket Image</div><br/>
                  </div>)}
              </div>
              </Grid>
        </Grid>
    </div></>
  );
//}
});
export default AssetImages;
